/* eslint-disable no-unused-vars */
import { TransactWriteCommandInput } from '@aws-sdk/lib-dynamodb';

/*
 * AAN / Aangevraagd
 * HUI / Aanvraag bij Huidige verhuurder
 * WAC / Wacht op Kandidaat
 * NIE / Wacht op beoordeling nieuwe verhuurder = Final step for tenant
 * AFG / Afgerond, geen opmerkingen
 * OPM / Afgerond, wel opmerkingen
 * ING / Ingetrokken door nieuwe verhuurder
 * STP / Stopgezet voor Kandidaat
 * REI / Re-issue request (geen officiele VERA status)
 */
export enum DeclarationStep {
  TENANT = 'HUI',
  CURRENT_LANDLORD = 'WAC',
  TENANT_CHECK = 'NIE',
  STOPPED_BY_TENANT = 'STP',
}

export enum CaseStep {
  NEW_LANDLORD_REQUEST = 'AAN',
  COMPLETED = 'AFG',
  COMPLETED_WITH_NOTES = 'OPM',
  WITHDRAWN_BY_NEW_LANDLORD = 'ING',
  RE_ISSUE_REQUEST = 'REI',
}

export const stepNumber = {
  [CaseStep.NEW_LANDLORD_REQUEST]: 1,
  [DeclarationStep.TENANT]: 2,
  [DeclarationStep.CURRENT_LANDLORD]: 3,
  [DeclarationStep.TENANT_CHECK]: 4,
  [DeclarationStep.STOPPED_BY_TENANT]: 5,
  [CaseStep.COMPLETED]: 6,
  [CaseStep.COMPLETED_WITH_NOTES]: 7,
  [CaseStep.WITHDRAWN_BY_NEW_LANDLORD]: 8,
  [CaseStep.RE_ISSUE_REQUEST]: 9,
} as const;

export const DECLARATION_DETAIL_TYPE: Record<DeclarationStep, string> = {
  [DeclarationStep.TENANT]: 'Declaration:Tenant',
  [DeclarationStep.CURRENT_LANDLORD]: 'Declaration:CurrentLandlord',
  [DeclarationStep.TENANT_CHECK]: 'Declaration:TenantCheck',
  [DeclarationStep.STOPPED_BY_TENANT]: 'Declaration:StoppedByTenant',
} as const;

export const CASE_DETAIL_TYPE: Record<CaseStep, string> = {
  [CaseStep.NEW_LANDLORD_REQUEST]: 'Case:NewLandlordRequest',
  [CaseStep.COMPLETED]: 'Case:Completed',
  [CaseStep.COMPLETED_WITH_NOTES]: 'Case:CompletedWithNotes',
  [CaseStep.WITHDRAWN_BY_NEW_LANDLORD]: 'Case:WithdrawnByNewLandlord',
  [CaseStep.RE_ISSUE_REQUEST]: 'Case:ReIssueRequest',
} as const;

export const STEP_TO_DETAIL_TYPE_INVALIDATED: Record<
  CaseStep | DeclarationStep,
  string
> = {
  [CaseStep.NEW_LANDLORD_REQUEST]: 'InvalidatedNewLandlordRequest',
  [DeclarationStep.TENANT]: 'InvalidatedTenant',
  [DeclarationStep.CURRENT_LANDLORD]: 'InvalidatedCurrentLandlord',
  [DeclarationStep.TENANT_CHECK]: 'InvalidatedTenantCheck',
  [CaseStep.COMPLETED]: 'InvalidatedCompleted',
  [CaseStep.COMPLETED_WITH_NOTES]: 'InvalidatedCompletedWithNotes',
  [CaseStep.WITHDRAWN_BY_NEW_LANDLORD]: 'InvalidatedWithdrawnByNewLandlord',
  [DeclarationStep.STOPPED_BY_TENANT]: 'InvalidatedStoppedByTenant',
  [CaseStep.RE_ISSUE_REQUEST]: 'InvalidatedReIssueRequest',
} as const;

export type DynamoActionCommand = NonNullable<
  TransactWriteCommandInput['TransactItems']
>[number];

export type PutActionCommand = Pick<DynamoActionCommand, 'Put'>;

export type DeleteActionCommand = Pick<DynamoActionCommand, 'Delete'>;

export type UpdateActionCommand = Pick<DynamoActionCommand, 'Update'>;

export interface DynamoActionWithData<Command extends DynamoActionCommand, T> {
  command: Command;
  data: T;
}

export type DynamoAction<Command extends DynamoActionCommand> = Command;

export interface NewDeclarationActionInput {
  declarationId?: string;
  userId: string;
  tenantId: string;
  formData: Record<string, unknown>;
  step: DeclarationStep;
}
